__turbopack_context__.v({
  "error": "_4zOhMq_error",
  "errorText": "_4zOhMq_errorText",
  "image": "_4zOhMq_image",
  "imageLoaded": "_4zOhMq_imageLoaded",
  "imageNotLoaded": "_4zOhMq_imageNotLoaded",
  "imageWrapper": "_4zOhMq_imageWrapper",
  "lazyImage": "_4zOhMq_lazyImage",
  "lazyImagePlaceholder": "_4zOhMq_lazyImagePlaceholder",
});
